import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import {
  moduleWorkspaceBodyClass,
  moduleWorkspaceContentClass,
  type ModuleWorkspaceContentWidth,
} from "@/components/module_summary/moduleWorkspaceLayout";

export type ModuleWorkspaceBodyProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  /** narrow = max-w-4xl, wide = max-w-[1800px], none = full width with standard vertical rhythm */
  width?: ModuleWorkspaceContentWidth;
};

export function ModuleWorkspaceBody({
  children,
  className,
  contentClassName,
  width = "none",
}: ModuleWorkspaceBodyProps) {
  return (
    <div className={cn(moduleWorkspaceBodyClass, className)} data-testid="module-workspace-body">
      <div className={cn(moduleWorkspaceContentClass(width), contentClassName)}>{children}</div>
    </div>
  );
}
